import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ChatWidget } from "../components/ChatWidget";
import { InstallButton } from "../components/InstallButton";
import { Bot, MapPin, Wrench, Loader2 } from "lucide-react";

export default function PublicReceptionist() {
  const { slug } = useParams();
  const [company, setCompany] = useState(undefined);

  useEffect(() => {
    api.get(`/public/company/${slug}`).then((r) => setCompany(r.data)).catch(() => setCompany(null));
  }, [slug]);

  if (company === undefined) return <div className="min-h-screen flex items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (company === null) return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
      <div className="text-center">
        <h1 className="font-display text-4xl tracking-tight">RECEPTIONIST NOT FOUND</h1>
        <p className="text-muted-foreground mt-2">This link doesn't match any business.</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background text-foreground grain">
      <div className="grid lg:grid-cols-[1fr_1.1fr] gap-8 px-6 md:px-12 py-10 max-w-6xl mx-auto" style={{ paddingTop: "calc(2.5rem + env(safe-area-inset-top))" }}>
        <div>
          <div className="flex items-center gap-2.5 mb-8">
            <div className="h-9 w-9 bg-primary rounded-sm flex items-center justify-center"><Bot className="h-5 w-5 text-white" /></div>
            <span className="text-xs uppercase tracking-widest text-muted-foreground flex-1">Powered by TradieDesk</span>
            <InstallButton always showLogo className="border-white/10 text-muted-foreground hover:text-foreground" label="Install app" />
          </div>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-3" data-testid="public-company-name">{company.name}</h1>
          <div className="flex flex-wrap gap-3 mb-6">
            {company.trade && <span className="inline-flex items-center gap-1.5 text-sm text-primary border border-primary/40 bg-primary/10 px-3 py-1.5 rounded-sm"><Wrench className="h-3.5 w-3.5" /> {company.trade}</span>}
            {company.area && <span className="inline-flex items-center gap-1.5 text-sm text-muted-foreground border border-white/10 px-3 py-1.5 rounded-sm"><MapPin className="h-3.5 w-3.5" /> {company.area}</span>}
          </div>
          {company.description && <p className="text-muted-foreground leading-relaxed max-w-md">{company.description}</p>}
          <div className="mt-8 bg-[#18181b] border border-white/10 rounded-sm p-4">
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-2">Need a job done?</p>
            <p className="text-sm">Chat with our AI receptionist Ava — she'll take your details and arrange a quick callback to get your job booked in, 24/7.</p>
          </div>
        </div>
        <div className="h-[640px]">
          <ChatWidget slug={slug} />
        </div>
      </div>
    </div>
  );
}
